export default {
  language: {
    Chinese: "中文",
    English: "英语",
    korea: "韩语",
    Japanese: "日语"
  },
  nav: {
    index: "首页",
    theme: "主题乐园",
    restaurant: "餐饮美食",
    activity: "主题活动",
    performance: "精彩演艺",
    service: "游客服务",
    online: "网上预订"
  },
  theme: [
    "长鹿尖叫岛", //0
    "童话动物王国", //1
    "长鹿度假村", //2
    "军事主题公园", //3
    "农家乐主题公园", //4
    "海底世界主题公园", //5
    "湿地主题公园" //6
  ],
  service: {
    work_time: "营业时间",
    traffic: "交通指南",
    map_title: "园区地图",
    problems_title: "常见问题",
    notice_title: "游客须知",
    complaints_title: "投诉建议",
    video_title: "视频专区",
    discount_title: "优惠信息",
      tour_server: '导游服务',
      security_check:'防伪查询'
  },
  traffic_type: ["自驾路线", "公交路线", "轻轨路线",'机场路线'],
  activity: ["缤纷活动", "特别优惠", "抢票活动"],
  footerNav: [
    "招贤纳士", //0
    "新闻中心", //1
    "联系我们", //2
    "关于长鹿", //3
    "企业介绍", //4
    "友情链接", //5
    "励志分享" //6
  ],
  name: "长鹿旅游休博园",
  cart: "进入购物车",
  theme_bg_tit: "主题背景",
  base_info: "基本信息", //基本信息
  resume: "个人履历", //尾页 招贤纳士 个人履历
  search_title: "全文搜素",
  service_tel: "客服热线", //客服电话热线
  address: "地址", //地址
  address_content: "广东省佛山市顺德伦教三洲建设东路",
  shop_cart: "购物车", //购物车名词
  traffic_system: "长鹿旅游休博园交通查询系统",
  map_download: "地图下载",
  order: "订单信息确认",
  pay_info: "支付成功",
  upload: "上传年卡资料",
  personal: "个人中心",
  card_bag: "我的卡包",
  login: "登录",
  register: "注册",
  join: "我的应聘",
  my_order: "我的订单",
  tourist_map: "导游图",
  work_type: ["社会招聘", "实习招聘", "管培生招聘", "兼职招聘"],
  enter_key: "请输入职位关键字", // 招贤纳士的占位符
  time_notice: "为了您可以掌握更多获得更多活动表演时间讯息，可以拨打咨询热线，",
  consult_tel: "咨询电话",
  online_type: ["门票预订", "酒店预订", "长鹿年卡", "特惠促销"],
  placeholder_verity: "请输入验证码",
  get_verity: "获取验证码",
  account: "账号登录",
  without_code: "免密登录",
  placeholder_code: "请输入账号",
  placeholder_psd: "请输入6-20位密码",
  placeholder_img_verity: "请输入图形验证码",
  placeholder_repeat_psd: "请再次输入密码",
  submit: "提交",
  send_code: "发送验证码",
  please_login: "请登入",
  experience: "工作经验",
  department: "工作部门",
  education: "学历要求",
  recruitment: "招聘类型",
  recruitment_number: "招聘人数",
  release_time: "发布时间",
  work_address: "工作地点",
  employ: "我要应聘",
  mouth: "月",
  newsNav: ["公司新闻", "园区公告"],
  view_count: "浏览次数",
  recent: "近期消息",
  education_bg: "教育背景",
  detail_address: "详细地址",
  save: "保存",
  submit_applications: "提交申请",
  certificate: "证书",
  tip: "请在执行下一步前将必填填写完并保存",
  placeholder_c: "请输入您要搜索的内容",
  contact_tel: "联系电话",
  switchboard: "总机",
  complaints_hotline: "投诉电话",
  Medical_phone: "医疗电话",
  house_phone: "消防电话",
  all_address:
    "广东省佛山市顺德伦教三洲建设东路长鹿旅游休博园（顺德伦教三洲与番禺沙湾交界处）",
  company: "广东长鹿旅游休博园有限公司",
  hotline: "咨询电话",
  hotline_tip: "(24小时服务热线)",
  placeholder_location: "请输入起始位置",
  notice_tip: "以上须知请游客遵守，不便之处敬请谅解！祝您旅途愉快",
  complaints_type: "投诉类型",
  select: "请选择",
  phone: "手机号码",
  placeholder_suggestion: "请写出你的意见",
  sure_submit: "确认提交",
  activity_time: "活动时间",
  still_time: "离活动结束时间还剩",
  start_time: "活动开始时间为",
  grab_num: "已抢数量",
  all: "共",
  piece: "张",
  select_time: "请选择出行日期",
  select_grab: "请选择抢票数量",
  activity_detail: "活动详情",
  past: "已结束",
  progress: "进行中",
  to: "至",
  show_time: "表演时间",
  placeholder_key: "按关键字搜索",
  job_title: "职位名称",
  depart: "所属部门",
  personal_data: "个人信息",
  head_portrait: "头像",
  compellation: "姓名",
  sex: "性别",
  sex_men: "男",
  sex_women: "女",
  birthday: "出生年月",
  contact_way: "联系方式",
  email: "邮箱地址",
  address_now: "现居地址",
  height: "身高",
  weight: "体重",
  academic: "最高学历",
  learning: "学习形式",
  academic_lists: [
    "小学",
    "初中",
    "中专",
    "高中",
    "大专",
    "本科",
    "研究生",
    "博士"
  ],
  learning_lists: [
    "全日制统招",
    "成人高考",
    "远程教育",
    "自考",
    "国家开发大学"
  ],
  job_intention: "求职意向",
  expected_salary: "期望月薪",
  arrival_time: "到岗时间",
  next: "下一步",
  placeholder_name: "请输入姓名",
  placeholder_birth: "请输入出生年月",
  placeholder_mail: "请输入邮箱地址",
  placeholder_way: "请输入联系方式",
  placeholder_address: "请输入地址",
  placeholder_height: "请输入身高",
  placeholder_weight: "请输入体重",
  placeholder_salary: "请输入期望的税前月薪",
  placeholder_arrival: "请选择到岗时间",
  upload_img: "上传图片",
  upload_detail: "*上传父母及儿童合照的近身半身照",
  idCard: "身份证号",
  placeholder_real_name: "请输入真实姓名",
  placeholder_idCard: "请填写身份证号码",
  placeholder_phone: "请填写手机号码",
  error_msg: "网络错误，请联系管理员",
  discount: "优惠券",
  date: "日期",
  score: "分",
  total_score: "积分总数",
  unused_score: "可用积分",
  used_score: "使用积分",
  detail_info: "详细信息",
  integration: "积分",
  order_num: "订单号：",
  use_hour: "使用时间：",
  contact_person: "联系人信息：",
  all_sum: "合计：",
  personal_info: "个人资料",
  certificate_card: "证件号码",
  age: "年龄",
  mail: "邮箱",
  submit_data: "提交个人信息",
  placeholder_age: "请输入年齡",
  placeholder_card: "请输入证件号码",
  placeholder_tel: "请输入手机号码",
  join_grab : "进入抢票",
  crazy: "疯狂",
  grabbing: "抢票中" ,
  notYet: "暂未",
  start: "开始",
  IC_case:'粤工商备',
  G_case :"粤ICP备",
    buyCar_empty:'您的购物车空空如也~',
    choose_goods: "选购商品",

};
